import React, { FunctionComponent } from 'react';
import { loginWithGooglePopup } from '../../../../../utils/auth0';
import googleIcon from '../../../../resources/images/google-icon.svg';

const GoogleSSOButton: FunctionComponent<{ onClick: (data: any) => void }> = ({ onClick }) => {
  const handleClick = async () => {
    try {
      const { user, token } = await loginWithGooglePopup();
      onClick({ user, token });
    } catch (err) {
      console.error('Auth0 error:', err);
    }
  };
  return (
    <div className="sso-login mb-2" onClick={handleClick}>
      <img src={googleIcon} className="h100 mr-1" />
      <span>Google</span>
    </div>
  );
};
export default GoogleSSOButton;
